<div class="w-100 questionaireBg" [ngClass]="lang_code === 'he' ? 'rtl' : 'ltr'">
  @if (!question_summary) {
    <div class="d-flex">
      <h4 class="font-weight-bold w-50">{{ chapter_name !== null ? chapter_name === 'baseline' ? 'Baseline' : chapter_name === '' ? 'Chapter-' + (chapter_index+1) : chapter_name : ''}}</h4>
      <div class="w-50 prog-wrapper d-flex justify-content-end mb-2">
        @for (count of counter(question_length); track count; let i = $index) {
          <div class="progItem mt-auto mb-auto" [ngClass]="i <= question_index ? 'progItem-highlighted' : ''"></div>
        }
      </div>
    </div>
  }

  <div class="questionaireSectionMain">
    <div class="videoWrapper mt-1 w-100">
      <div class="ql-container ql-snow" style="border-width: 0;">
        @if (sanitizedContent) {
          <div class="ql-editor" [innerHTML]="sanitizedContent"></div>
        }
        @if (question.body.link_type === 'VIDEO') {
          <div class="ratio ratio-16x9">
            <iframe [src]="safeUrl" allowfullscreen></iframe>
          </div>
        }
        @if (question.body.link_type === 'AUDIO') {
          <div class="text-center">
            <audio controls>
              <source [src]="safeUrl" type="audio/mpeg">
              <source [src]="safeUrl" type="audio/aac">
              <source [src]="safeUrl" type="audio/mpeg">
              <source [src]="safeUrl" type="audio/ogg">
              The browser does not support the audio element.
            </audio>
          </div>
        }
      </div>
    </div>

    @if (question.response.response_type && (question.response.response_type !== 'VISUAL')) {
      <div class="rightSideBlock">
        <div class="base pt-2 radioRemoveDisabled">
          <div class="row">
            <div class="d-flex gap-3 align-items-middle">
              @if (question.response.response_type === 'VOICE') {
                <img src="../../../../../assets/images/svg/audio.svg" alt="test" class="icons-audio my-auto" />
              }
              <div class='d-flex flex-column'>
                @if (currentAction) {
                  <p class="title-margin title my-auto">{{ 'ASSESSMENTAPP.RESPONSE.' + currentAction | translate }}</p>
                }
                @if (currentQuestionSubtitle) {
                  <p class="remove-margin text my-auto">{{'ASSESSMENTAPP.RESPONSE.' + currentQuestionSubtitle | translate }}</p>
                }
              </div>
              @if (question.response.response_type === 'VOICE') {
                <div [ngClass]="lang_code === 'he' ? 'me-auto' : 'ms-auto'" class="d-flex align-items-center gap-2">
                  <!-- <div *ngIf="alert_before > 0" class="fs-16 text-danger">Auto recording will start in {{ alert_before }}</div>  -->
                  @if (!isRecorded) {
                    <div class="fs-24">{{ formatTime(record_timer) }}</div>
                  }
                  <button [disabled]="isRecorded || report" type="button" (click)="isRecording ? stopRecording() : record()" [ngClass]="isRecording ? 'btn-danger' : isRecorded ? 'btn-primary' : 'btn-success'" class="d-flex btn personalDetailNextBtn questionaireNextBtn">
                    {{ 'ASSESSMENTAPP.RESPONSE.' + (isRecording ? 'STOP' : isRecorded ? 'RECORDED' : 'RECORD') | translate }}
                  </button>
                </div>
              }
            </div>
          </div>
          <div class="row">
            @if (question.response.response_type === 'RANGE' && question.response.response_range) {
              <div class="d-flex w-100 mt-2 justify-content-between ps-4 pe-4">
                @for (count of getNumbers(question.response.response_range.range_min, question.response.response_range.range_max); track count; let i = $index) {
                  <div class="radioBtnMain"
                    >
                    <div class="form-radio-outline form-radio-info d-flex justify-content-center">
                      <input class="form-check-input" type="radio" name="formradiocolor14" placeholder="option"
                        (change)="onRangeOptionSelected($event, count)" [checked]="selectedRangeOption === count" [disabled]="report">
                    </div>
                    <p class="m-0 mt-1 text-center">{{count}}</p>
                    @if (count === question.response.response_range.range_min) {
                      <p class="m-0 text-center"> ({{ question.response.response_range.range_label_min }})</p>
                    }
                    @if (count === question.response.response_range.range_max) {
                      <p class="m-0 text-center"> ({{ question.response.response_range.range_label_max }})</p>
                    }
                  </div>
                }
              </div>
            }
            @if (question.response.response_type === 'SELECT') {
              <div class="w-100 mt-2 justify-content-center ps-4 pe-4">
                @if (question.response.response_select?.multi_select) {
                  <div class="list-group">
                    @for (option of question.response.response_select?.response_options; track option) {
                      <label class="list-group-item">
                        <input class="form-check-input" [ngClass]="lang_code === 'he' ? 'ms-1' : 'me-1'" type="checkbox" [checked]="checkValueInSelectedOptionList(option)"
                          (change)="onSelectResponseChange($event, option)" [disabled]="report">
                        {{option.label}}
                      </label>
                    }
                  </div>
                }
                @if (!question.response.response_select?.multi_select) {
                  <div class="list-group">
                    @for (option of question.response.response_select?.response_options; track option) {
                      <label class="list-group-item">
                        <input class="form-check-input fs-14 mt-0 align-middle" [ngClass]="lang_code === 'he' ? 'ms-1' : 'me-1'" type="radio" [checked]="selectedOptions.length > 0 && (selectedOptions[0].label === option.label)"
                        (change)="onSelectResponseChange($event, option)" [disabled]="report">
                        {{option.label}}
                      </label>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>